import { CatalogOtherCostVariableTypeEnum } from 'gql/graphql';
import type { ChoiceGroupDefaultItem } from 'uikit';

import type { DefaultValues } from 'react-hook-form';

import type { FieldValuesCreateOrEditStructure, RadioGroupItem } from '../types';

export const DefaultFromValues: DefaultValues<FieldValuesCreateOrEditStructure> = {
    type: { label: CatalogOtherCostVariableTypeEnum.Simple },
};

export const TypeItems: ChoiceGroupDefaultItem[] = [
    {
        label: CatalogOtherCostVariableTypeEnum.Simple,
    },
    {
        label: CatalogOtherCostVariableTypeEnum.Composite,
    },
    {
        label: CatalogOtherCostVariableTypeEnum.OtherCostType,
    },
];

export const LinkTypeRadioItems: RadioGroupItem<CatalogOtherCostVariableTypeEnum>[] = [
    { label: 'Прочие', id: CatalogOtherCostVariableTypeEnum.OtherCostType },
    { label: 'Лимитированные', id: CatalogOtherCostVariableTypeEnum.LimitedCostType },
];

export const OTHER_COST_TYPE_PLACEHOLDER = 'Тип прочих';
export const LIMITED_COST_TYPE_PLACEHOLDER = 'Тип лимитированных';

export const OTHER_COST_TYPE_TOOLTIP =
    'Добавить новый тип прочих можно на странице Справочника переменных для формул прочих затрат';

export const LIMITED_COST_TYPE_TOOLTIP =
    'Добавить новый тип лимитированных можно на странице Справочника переменных для формул лимитированных затрат';
